exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._3BmmsO9VQ6QQnEzu7V_GHm{width:100%;margin:0 auto}", ""]);

// exports
exports.locals = {
	"surface": "_3BmmsO9VQ6QQnEzu7V_GHm",
	"surface": "_3BmmsO9VQ6QQnEzu7V_GHm"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&camelCase!./~/postcss-loader!./src/styles/Surface.css
// module id = 484
// module chunks = 0